import React from 'react';
import styled from 'styled-components';
import { string } from 'prop-types';
import {
  formatTime,
  DATE_FORMAT_DEFAULT,
} from '@airasia-common/libraries/datetime';
import BaseTextInput from './BaseTextInput';

const StyledTextInput = styled(BaseTextInput)`
  outline: none;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  &::placeholder {
    color: ${({ theme }) => theme.colors.greyDark};
    opacity: 0.5;
  }
  &:disabled {
    background-color: ${({ theme }) => theme.colors.greyLighter};
  }
`;

const StyledDateInput = styled(StyledTextInput)`
  position: relative;
  height: 20px;
  font-size: 0;
  background-color: white;
  -webkit-appearance: none;
  &::before {
    position: absolute;
    top: 3px;
    left: 0;
    top: 0;
    content: attr(data-display);
    line-height: 1;
    display: inline-block;
    color: ${props =>
      props.isDisplayPlaceholder
        ? props.theme.colors.greyDark
        : props.theme.colors.darkBlack};
    opacity: ${props => (props.isDisplayPlaceholder ? 0.5 : 1)};
    font-size: 16px;
  }
  &::-webkit-datetime-edit,
  &::-webkit-inner-spin-button,
  &::-webkit-clear-button {
    display: none;
  }
  &::-webkit-calendar-picker-indicator {
    position: absolute;
    top: 3px;
    right: 0;
    opacity: 1;
    font-size: 16px;
  }
`;

const StyledInput = props => {
  const { value, placeholder, type } = props;
  function hasValue() {
    return value && value.trim() !== '';
  }
  function isDateInput() {
    return type && type === 'date';
  }

  if (isDateInput()) {
    return (
      <StyledDateInput
        isDisplayPlaceholder={!hasValue()}
        data-display={
          hasValue()
            ? formatTime(new Date(value), DATE_FORMAT_DEFAULT)
            : placeholder
        }
        {...props}
      />
    );
  }
  return <StyledTextInput {...props} />;
};

StyledInput.propTypes = {
  type: string,
  value: string,
  placeholder: string,
};

StyledInput.defaultProps = {
  width: 1,
  border: 'none',
  fontSize: 16,
  color: 'darkBlack',
  fontWeight: 400,
  margin: 0,
  padding: 0,
  placeholder: '',
};

export default StyledInput;
